import React from 'react';
import ReactTooltip from 'react-tooltip';
import interrogationImage from '../../img/svg.svg';
import './index.css';

function HelpBallon(props) {
  return (
    <>
      {props.noImage ? null : (
        <img
          src={interrogationImage}
          className="img-info"
          data-tip={props.message}
          data-for={props.id}
          alt=""
        />
      )}

      <ReactTooltip
        id={props.id}
        className="baloon"
        place={props.place || 'right'}
        type="dark"
        effect="solid"
      />
    </>
  );
}

export default HelpBallon;
